import React, { useEffect, useState, useRef } from 'react';

import { NoItemRow } from '../../../../../utils/loader/loadingHelper';
import loader from '../../../../../../src/assets/img/icons/TizetiLoaderColored.gif';
import { API_URL } from '../../../../../utils/config';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';

export default function InvoicesBody() {
  const [lists, setLists] = useState([]);
  const [view, setView] = useState(false);
  const [editType, setEditType] = useState('');
  const [recordId, setRecordId] = useState(null);
  const [isLoading, setIsloading] = useState(false);
  const [editDetails, setEditDetails] = useState({});
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  const fetchData = async () => {
    setIsloading(true);
    const url = `${API_URL}/planList/getWificallInvoiceData`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
    });

    if (response.ok) {
      const data = await response.json();
      setLists([...data]);
      setIsloading(false);
      return;
    }

    toast.error('Something went wrong...');
    setIsloading(false);
  };

  useEffect(() => {
    (async () => { await fetchData(); })();
  }, []);

  const filtered = lists.filter((item) => {
    const term = search.toLowerCase();
    const matchesSearch =
      !term ||
      (item.company || '').toLowerCase().includes(term) ||
      (item.email || '').toLowerCase().includes(term) ||
      (item.username || '').toLowerCase().includes(term);
    const matchesStatus = !statusFilter || item.payment_status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  return (
    <main className="container-fluid col-12 my-2">
      <div className="row mx-2 mt-4 align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <div className="input-group mr-3" style={{ width: '260px' }}>
            <div className="input-group-prepend">
              <span className="input-group-text bg-white border-right-0">
                <i className="fa fa-search text-muted" />
              </span>
            </div>
            <input
              className="form-control border-left-0"
              type="text"
              placeholder="Search company, email, username..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <select
            className="form-control"
            style={{ width: '160px' }}
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="">All Statuses</option>
            <option value="paid">Paid</option>
            <option value="not_paid">Not Paid</option>
          </select>
        </div>

        <button
          className="btn btn-green"
          onClick={() => { setView(true); setEditType('add'); setEditDetails({}); }}
        >
          <i className="fa fa-plus mr-2" />
          Add Invoice
        </button>
      </div>

      <InvoicesTable
        isLoading={isLoading}
        lists={filtered}
        setView={setView}
        setEditType={setEditType}
        setRecordId={setRecordId}
        fetchData={fetchData}
        setEditDetails={setEditDetails}
      />

      <AddInvoice
        view={view}
        setView={setView}
        fetchData={fetchData}
        editType={editType}
        recordId={recordId}
        editDetails={editDetails}
      />
    </main>
  );
}

function InvoicesTable({ isLoading, lists, setView, setEditType, setRecordId, fetchData, setEditDetails }) {
  const [deletingId, setDeletingId] = useState(null);

  const handleDelete = async (id) => {
    setDeletingId(id);
    const url = `${API_URL}/planList/changeWificallInvoiceDetails`;
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id, type: 'delete' }),
    });

    if (response.ok) {
      toast.success('Record deleted');
      fetchData();
    }
    setDeletingId(null);
  };

  const tableData =
    lists && lists.length > 0 ? (
      lists.map((item, i) => (
        <tr key={item.id || i}>
          <td>{i + 1}</td>
          <td className="text-nowrap">{item.company}</td>
          <td className="text-nowrap">{item.email}</td>
          <td className="text-nowrap">{item.username || 'N/A'}</td>
          <td className="text-nowrap">{item.address || 'N/A'}</td>
          <td>{item.month}</td>
          <td>{item.charge ? `₦${Number(item.charge).toLocaleString()}` : 'N/A'}</td>
          <td>{item.sending_interval}</td>
          <td className="text-nowrap">{item.next_sending_date}</td>
          <td>
            {item.payment_status === 'paid' ? (
              <span className="badge badge-success" style={{ fontSize: '0.8em', padding: '5px 10px' }}>Paid</span>
            ) : item.payment_status === 'not_paid' ? (
              <span className="badge badge-danger" style={{ fontSize: '0.8em', padding: '5px 10px' }}>Not Paid</span>
            ) : (
              <span className="badge badge-secondary" style={{ fontSize: '0.8em', padding: '5px 10px' }}>N/A</span>
            )}
          </td>
          <td className="text-nowrap">
            <button
              title="Edit"
              onClick={() => { setView(true); setEditType('edit'); setRecordId(item.id); setEditDetails({ ...item }); }}
              className="btn btn-sm btn-outline-info mr-2"
              style={{ width: '32px', height: '32px', padding: 0 }}
            >
              <i className="fa fa-pencil" />
            </button>
            <button
              title="Delete"
              onClick={() => handleDelete(item.id)}
              disabled={deletingId === item.id}
              className="btn btn-sm btn-outline-danger"
              style={{ width: '32px', height: '32px', padding: 0 }}
            >
              {deletingId === item.id
                ? <i className="fa fa-spinner fa-spin" />
                : <i className="fa fa-trash" />}
            </button>
          </td>
        </tr>
      ))
    ) : (
      <NoItemRow colSpan={11} text="No records found" />
    );

  return (
    <div className="card x-panel p-0 mt-3 mx-2">
      <div className="table-responsive content col-12 px-0">
        <table className="table table-hover copy-font mb-0">
          <thead className="thead-light">
            <tr>
              <th>#</th>
              <th className="text-nowrap">Company</th>
              <th className="text-nowrap">Email</th>
              <th className="text-nowrap">Username</th>
              <th className="text-nowrap">Address</th>
              <th className="text-nowrap">Qty</th>
              <th className="text-nowrap">Charge</th>
              <th className="text-nowrap">Interval</th>
              <th className="text-nowrap">Next Sending Date</th>
              <th className="text-nowrap">Payment Status</th>
              <th className="text-nowrap">Actions</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={11} className="text-center py-4">
                  <img src={loader} alt="loading" />
                </td>
              </tr>
            ) : tableData}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function AddInvoice({ view, setView, fetchData, editType, recordId, editDetails }) {
  const handleClose = () => setView(false);
  const ref = useRef();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!ref.current) return;

    setLoading(true);
    const form = new FormData(ref.current);

    const body = {
      company: form.get('company'),
      email: form.get('email'),
      username: form.get('username'),
      charge: Number(form.get('charge')),
      month: Number(form.get('month')),
      address: form.get('address'),
      sending_interval: form.get('sending_interval'),
      payment_status: form.get('payment_status') || undefined,
    };

    if (editType === 'edit') {
      for (let i in body) {
        if (!body[i]) delete body[i];
      }
      body.type = editType;
      if (recordId) body.id = recordId;
    }

    const url =
      editType === 'add'
        ? `${API_URL}/planList/addWificallInvoiceDetails`
        : `${API_URL}/planList/changeWificallInvoiceDetails`;

    const response = await fetch(url, {
      method: editType === 'edit' ? 'PATCH' : 'POST',
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (response.ok) fetchData();
    setLoading(false);
    setView(false);
  };

  const {
    company = '',
    email = '',
    username = '',
    address = '',
    month = '',
    charge = '',
    sending_interval = '',
    payment_status = '',
  } = editDetails;

  return (
    <Modal show={view} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ paddingLeft: '2rem' }}>
          {editType === 'edit' ? 'Edit Invoice Details' : 'Add Invoice Details'}
        </Modal.Title>
      </Modal.Header>

      <div className="modal-body">
        <div className="py-3">
          <form ref={ref} onSubmit={handleSubmit} className="col-md-12">
            <div className="pt-2 d-flex">
              <div className="pr-3 form-group col-md-6">
                <label className="m-0 p-0 copy-font">Company {editType === 'add' && <span className="text-danger">*</span>}</label>
                <input className="form-control border border-info py-2" type="text" placeholder="Company name" defaultValue={company} name="company" required={editType === 'add'} />
              </div>
              <div className="pl-3 form-group col-md-6">
                <label className="m-0 p-0 copy-font">Email {editType === 'add' && <span className="text-danger">*</span>}</label>
                <input className="form-control border border-info py-2" type="email" placeholder="user@company.com" defaultValue={email} name="email" required={editType === 'add'} />
              </div>
            </div>

            <div className="d-flex">
              <div className="pr-3 form-group col-md-6">
                <label className="m-0 p-0 copy-font">Username {editType === 'add' && <span className="text-danger">*</span>}</label>
                <input className="form-control border border-info py-2" type="text" placeholder="Username" defaultValue={username} name="username" required={editType === 'add'} />
              </div>
              <div className="pl-3 form-group col-md-6">
                <label className="m-0 p-0 copy-font">Address</label>
                <input className="form-control border border-info py-2" type="text" placeholder="Address" name="address" defaultValue={address} />
              </div>
            </div>

            <div className="d-flex">
              <div className="pr-3 form-group col-md-6">
                <label className="m-0 p-0 copy-font">Charge (₦) {editType === 'add' && <span className="text-danger">*</span>}</label>
                <input className="form-control border border-info py-2" type="number" placeholder="e.g. 10000" name="charge" defaultValue={charge} required={editType === 'add'} />
              </div>
              <div className="pl-3 form-group col-md-6">
                <label className="m-0 p-0 copy-font">Month Quantity {editType === 'add' && <span className="text-danger">*</span>}</label>
                <input className="form-control border border-info py-2" type="number" placeholder="e.g. 1" name="month" defaultValue={month} required={editType === 'add'} />
              </div>
            </div>

            <div className="d-flex">
              <div className="pr-3 form-group col-md-6">
                <label className="m-0 p-0 copy-font">Month Interval</label>
                <input className="form-control border border-info py-2" type="number" placeholder="e.g. 1" name="sending_interval" defaultValue={sending_interval} />
              </div>
              <div className="pl-3 form-group col-md-6">
                <label className="m-0 p-0 copy-font">Payment Status</label>
                <select className="form-control border border-info py-2" name="payment_status" defaultValue={payment_status}>
                  <option value="">-- Select Status --</option>
                  <option value="not_paid">Not Paid</option>
                  <option value="paid">Paid</option>
                </select>
              </div>
            </div>

            <div className="text-center mt-3">
              <button type="submit" className="btn btn-green py-2 px-5" disabled={loading}>
                {loading ? 'Saving...' : editType === 'edit' ? 'Save Changes' : 'Add Invoice'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
